import { getHeadTrackingScript, getNoscriptTrackingScript } from "@DSG/Overrides/Common/Utilities/tracking";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    LookUpData,
    SetHeadTrackingScript,
    SetNoscriptTrackingScript,
    chain,
} from "@insite/client-framework/Store/CommonHandlers/SetTracking";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// get the type of props using this
type TrackingParameters = Parameters<typeof LookUpData>[0];
replaceInChain(chain, SetNoscriptTrackingScript, SetNoscriptTrackingScriptExt);
function SetNoscriptTrackingScriptExt(props: TrackingParameters) {
    const noscriptTrackingScript = getNoscriptTrackingScript(props.settings);
    if (noscriptTrackingScript) {
        let noscript = document.getElementById("noscriptTrackingScript");
        if (!noscript) {
            noscript = document.createElement("noscript");
            noscript.setAttribute("id", "noscriptTrackingScript");
            noscript.innerHTML = noscriptTrackingScript;
            document.body.appendChild(noscript);
        }
    }
}

replaceInChain(chain, SetHeadTrackingScript, SetHeadTrackingScriptExt);
function SetHeadTrackingScriptExt(props: TrackingParameters) {
    const headTrackingScript = getHeadTrackingScript(props.settings, props.session);
    if (headTrackingScript) {
        let script = document.getElementById("headTrackingScript");
        if (!script) {
            const { googleTrackingTypeComputed, googleTrackingAccountId } =
                props.settings.settingsCollection.websiteSettings;

            if (googleTrackingTypeComputed === "GoogleAnalytics4") {
                const GA4Script = document.createElement("script");
                GA4Script.setAttribute("id", "GA4Tracking");
                GA4Script.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${googleTrackingAccountId}`);
                document.head.appendChild(GA4Script);
            }

            script = document.createElement("script");
            script.setAttribute("id", "headTrackingScript");
            script.innerHTML = headTrackingScript;
            document.head.appendChild(script);
        }
    }
}
